import { useContext } from "react";
import { CgCloseO } from "react-icons/cg";
import { ActionType, ModalsContext } from "../../Components/Contexts/ModalsContext";
import "./LoadingNotification.css";
import Loader from "react-js-loader";

function LoadingNotification({ text }) {
  const { dispatch } = useContext(ModalsContext);

  return (
    <div className="modal-no-background notification-modal">
      <div id="LoadingNotification" className="small-modal">
        <div
          className="modal-title"
          style={{ backgroundColor: "inherit", alignItems: "flex-end", justifyContent: "flex-end" }}
        >
          <button
            className="close-modal-btn"
            style={{ color: "black" }}
            onClick={() => {
              dispatch({
                type: ActionType.setShowLoadingNotificationModal,
              });
            }}
          >
            <CgCloseO size={25} />
          </button>
        </div>
        <div className="modal-data notification-modal-data">
          <Loader type="spinner-default" bgColor={"#999999"} size={70} />
          <div className="loading-notification-text">{text}</div>
        </div>
      </div>
    </div>
  );
}

export default LoadingNotification;
